export const global = {
  login: 'Autentificare',
  logout: 'Iesire',
  tableShowingToFrom: 'Arata de la {showing} pana la {to} din {from}',
  tableSearch: 'Introduceti cuvantul cheie...',
  loading: 'Loading...'
}
